// Slider — native range input with a brand-filled track. The filled portion
// is drawn from a `--app-slider-fill` custom property computed off
// value/min/max (WebKit paints no progress fill of its own; Firefox's
// ::-moz-range-progress is styled too, so the variable is the single source).

import { forwardRef, type CSSProperties, type InputHTMLAttributes } from 'react';

export interface SliderProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Current value (controlled usage — the fill is derived from it). */
  value: number;
}

const Slider = forwardRef<HTMLInputElement, SliderProps>(function Slider(
  { className = '', min = 0, max = 100, value, style, ...rest },
  ref,
) {
  const lo = Number(min);
  const hi = Number(max);
  const pct = hi > lo ? Math.min(100, Math.max(0, ((value - lo) / (hi - lo)) * 100)) : 0;
  const classes = ['app-slider', className].filter(Boolean).join(' ');

  return (
    <input
      ref={ref}
      type='range'
      className={classes}
      min={min}
      max={max}
      value={value}
      style={{ ...style, '--app-slider-fill': `${pct}%` } as CSSProperties}
      {...rest}
    />
  );
});

export default Slider;
